import React from 'react';
import { Platform } from 'react-native';
import { Box, useToken } from '@gluestack-ui/themed';
import Quill from '../../../../common/components/Quill';

export interface QuillHandle {
  setHtml: (newHtml: string) => Promise<void>;
  getHtml: () => string;
}

export interface EditorShellProps {
  testID?: string;
  initialHtml?: string;
  onHtmlChange?: (html: string, meta?: unknown) => void;
  onShowHistory?: () => void;
  readonly?: boolean;
  placeholder?: string;
  showHistoryControl?: boolean;
  borderless?: boolean;
}

const EditorShell = React.forwardRef<QuillHandle, EditorShellProps>(
  (
    {
      testID,
      initialHtml,
      onHtmlChange,
      onShowHistory,
      readonly,
      placeholder,
      showHistoryControl = true,
      borderless = false,
    },
    ref,
  ) => {
    const borderColor = useToken('colors', 'borderLight200') as string;

    return (
      <>
        {Platform.OS === 'web' && !borderless && (
          <style>
            {`
            .ql-toolbar.ql-snow,
            .ql-container.ql-snow {
              border: none;
              border-radius: 0;
            }
            .ql-snow .ql-editor {
              border-radius: 0;
            }
            div.ql-toolbar {
              border-radius: 8px !important;
              border: 1px solid ${borderColor} !important;
              margin-bottom: 10px !important;
            }
          `}
          </style>
        )}
        <Box flex={1} {...(Platform.OS === 'web' ? { className: 'composer-quill' } : {})} mb={borderless ? 0 : '$5'}>
          <Quill
            testID={`${testID}-editor`}
            ref={ref as React.Ref<QuillHandle>}
            initialHtml={initialHtml}
            compact
            onHtmlChange={onHtmlChange}
            onShowHistory={onShowHistory}
            showHistoryControl={showHistoryControl}
            readonly={readonly}
            placeholder={placeholder}
            borderless={borderless}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ flex: 1 }}
          />
        </Box>
      </>
    );
  },
);

export default EditorShell;
